import { defineMessages } from 'react-intl';

const messages = defineMessages({
  deleteAttachmentTitle: {
    id: 'Assignment.Attachment.deleteAttachmentTitle',
    defaultMessage: 'Delete attachment',
  },
  type: {
    id: 'Assignment.Attachment.type',
    defaultMessage: 'Type:',
  },
  size: {
    id: 'Assignment.Attachment.size',
    defaultMessage: 'Size:',
  },
  uploaded: {
    id: 'Assignment.Attachment.uploaded',
    defaultMessage: 'Uploaded:',
  },
  socketServerValidating: {
    id: 'Assignment.Attachment.socketServerValidating',
    defaultMessage: 'The file is under validation, wait a while.',
  },
});

export default messages;
